const BIDI_CONTROL_REGEX = /[\u061c\u200e\u200f\u202a-\u202e\u2066-\u2069\ufeff]/g;
const ARABIC_CHAR_REGEX = /[\u0600-\u06ff]/;
const LATIN_CHAR_REGEX = /[A-Za-z]/;

export function sanitizeDirectionalText(value) {
  return typeof value === "string" ? value.replace(BIDI_CONTROL_REGEX, "") : value;
}

export function getTextDirection(value) {
  const text = sanitizeDirectionalText(value);
  if (!text) return "rtl";

  for (const character of text) {
    if (ARABIC_CHAR_REGEX.test(character)) return "rtl";
    if (LATIN_CHAR_REGEX.test(character)) return "ltr";
  }

  return "rtl";
}

export function getDirectionalText(value) {
  const text = sanitizeDirectionalText(value) || "";
  return { text, dir: getTextDirection(text) };
}
